import { Injectable } from '@angular/core';

import {Const} from '../const/const';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TokenService} from './token.service';
import {User} from '../models/user.model';
import {Observable, ReplaySubject} from 'rxjs';
import {Auth} from '../models/auth.model';
import 'rxjs/add/operator/map';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    private user: User;
    private observable = new ReplaySubject<Auth>(1);

    constructor(
        private http: HttpClient,
        private token: TokenService,
    ) {
        this.verifyToken(true);
    }

    private noticeAuth(loggedIn: boolean = false, user: User = null) {
        const auth: Auth = {
          isLogIn: loggedIn,
          user: user
        };
        this.observable.next(auth);
    }

    private verifyToken(tryRenew: boolean = true) {

        if (this.token.hasAccessToken()) {

            let headers = new HttpHeaders();
            headers = headers.set('Authorization', 'Bearer ' + this.token.getAccessToken());
            headers = headers.set('show_login', 'false');
            this.http.get(Const.baseAPI + '/user', {
                withCredentials: true,
                headers: headers
            }).subscribe(
                (resp) => {
                    this.user = <User>resp;
                    this.noticeAuth(true, this.user);
                },
                (error) => {
                    this.token.clearAccessToken();
                    if (this.token.hasRefreshToken() && tryRenew) {
                        this.renewAccessToken();
                    } else {
                        this.noticeAuth(false, null);
                    }
                }
            );

        } else if (this.token.hasRefreshToken() && tryRenew) {
            this.renewAccessToken();
        } else {
            this.noticeAuth(false, null);
        }
    }

    private sendTokenRequest(data): Observable<boolean> {
        return this.http.post(Const.auth.tokenURL, data)
          .pipe(
            map((resp: any) => {
              this.token.store(resp.access_token, resp.refresh_token, data.remember);
              this.verifyToken(false);
              return true;
            }
          ));
    }

    private renewAccessToken() {
        const data = {
            'grant_type': 'refresh_token',
            'client_id': Const.auth.clientId,
            'client_secret': Const.auth.clientSecret,
            'refresh_token': this.token.getRefreshToken(),
            'scope': Const.auth.defaultScope
        };
        this.sendTokenRequest(data).subscribe(
            (next) => {},
            (error) => {
                this.noticeAuth(false, null);
            }
        );
    }

    login(username: string, password: string, remember: boolean): Observable<boolean> {
        const data = {
            'grant_type': 'password',
            'client_id': Const.auth.clientId,
            'client_secret': Const.auth.clientSecret,
            'username': username,
            'password': password,
            'scope': Const.auth.defaultScope,
            'remember': remember
        };
        return this.sendTokenRequest(data);
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        this.token.clear();
        this.noticeAuth(false, null);
    }

    /**
     * @Deprecated
     * @returns {boolean}
     */
    isLoggedIn() {
        return this.token.hasAccessToken();
    }

    getAuth(): Observable<Auth> {
        return this.observable;
    }

    getEmailByToken(token: string) {
        return this.http.get(Const.baseAPI + '/get-email-token/' + token);
    }

    can(permission: string) {
        return true;
    }

    checkTypeLogin(username, type) {
        return this.http.get(Const.baseAPI + '/check-type-login/' + username + '/' + type);
    }
}
